import React from 'react';
import { MessageCircle, Send, Clock, Users } from 'lucide-react';
import { useToggleAnimation, getAnimationClasses, getAnimationStyles } from '../hooks/useToggleAnimation';
import { WHATSAPP_URL, trackCTAClick } from '../analytics';
import CTAButton from './CTAButton';
import './AnimatedChatSection.css';

const AnimatedChatSection = () => {
  const { isOpen, isAnimating, toggle, autoClose } = useToggleAnimation(false, 300);

  const handleChatClick = () => {
    trackCTAClick('chat_section_cta', window.location.pathname + window.location.search + window.location.hash);
    window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
    autoClose(1000); // Auto close after 1 second
  };

  return (
    <section className="animated-chat-section">
      <div className="section-container">
        <div className="chat-wrapper">
          {/* Main Chat Button */}
          <button
            className={`chat-toggle-btn ${getAnimationClasses(isOpen, isAnimating, 'toggle-btn')}`}
            onClick={toggle}
            disabled={isAnimating}
            aria-label={isOpen ? "Tutup chat" : "Buka chat"}
          >
            <div className="btn-icon">
              {isOpen ? <Send size={24} /> : <MessageCircle size={24} />}
            </div>
            <span className="btn-text">
              {isOpen ? 'Tutup' : 'Chat dengan Kami'}
            </span>
            <div className="btn-status">Online</div>
          </button>

          {/* Expanded Chat Content */}
          <div 
            className={`chat-content ${getAnimationClasses(isOpen, isAnimating, 'content')}`}
            style={getAnimationStyles(isOpen, isAnimating)}
          >
            <div className="content-header">
              <div className="header-icon">
                <MessageCircle size={32} />
              </div>
              <div className="header-text">
                <h2 className="header-title">Chat Langsung</h2>
                <p className="header-subtitle">
                  Dapatkan jawaban cepat untuk pertanyaan Anda
                </p>
              </div>
            </div>

            <div className="chat-features">
              <div className="feature-item">
                <Clock size={16} />
                <span>Respon &lt; 5 menit</span>
              </div>
              <div className="feature-item">
                <Users size={16} />
                <span>Tim profesional siap membantu</span>
              </div>
            </div>

            <div className="chat-actions">
              <CTAButton
                variant="whatsapp"
                size="medium"
                href={WHATSAPP_URL}
                isWhatsApp={true}
                trackingLabel="chat_section_cta_expanded"
                fullWidth={true}
                onClick={handleChatClick}
              >
                Mulai Chat Sekarang
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnimatedChatSection;
